import { render, staticRenderFns } from "./DocumentUploadItem.vue?vue&type=template&id=54f8c1f4&scoped=true"
import script from "./DocumentUploadItem.vue?vue&type=script&lang=js"
export * from "./DocumentUploadItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8c1f4",
  null
  
)

export default component.exports